import { isUndefined } from 'lodash'

const INTERNSHIPS_MANAGER_ROOT = 'internships-manager-view'
const INTERNSHIPS_REQUEST_ROOT = 'internships-request-view'
const GLOBAL_FILTERS_ROOT = 'global-filters'
const QUOTAS_TABLE_ROOT = 'quotas-table'
const PLACES_TABLE_ROOT = 'places-table'
const PLACES_OCCUPANCY_VIEW_ROOT = 'places-occupancy-view'
const MISC_ROOT = 'miscellaneous'
const STUDENTS_VIEW_ROOT = 'students-view'

class LocalStorageManipulator {
  get (storageKey) {
    const item = window.localStorage.getItem(storageKey)

    return item === null ? null : JSON.parse(item)
  }

  set (storageKey, item) {
    return window.localStorage.setItem(storageKey, JSON.stringify(item))
  }

  remove (storageKey) {
    return window.localStorage.removeItem(storageKey)
  }

  has (storageKey) {
    return window.localStorage.getItem(storageKey) !== null
  }

  add (storageKey, { key, value }) {
    let storeItem = {}

    if (this.has(storageKey)) {
      storeItem = this.get(storageKey)
    }

    storeItem[key] = value
    this.set(storageKey, storeItem)
  }

  removeValue (storageKey, key) {
    if (this.has(storageKey)) {
      const storeItem = this.get(storageKey)

      if (storeItem && storeItem[key]) {
        delete storeItem[key]
        this.set(storageKey, storeItem)
      }
    }
  }

  getValue (storageKey, key) {
    let storeValue = null

    if (this.has(storageKey)) {
      storeValue = this.get(storageKey)

      storeValue = storeValue === null || isUndefined(storeValue[key]) ? null : storeValue[key]
    }

    return storeValue
  }
}

export const localStorage = new LocalStorageManipulator()

const LOCAL_STORAGE_KEYS = Object.freeze({
  INTERNSHIPS_MANAGER: Object.freeze({
    ROOT: INTERNSHIPS_MANAGER_ROOT,
    PRECISION: INTERNSHIPS_MANAGER_ROOT + '.precision',
    PARAMETERS: INTERNSHIPS_MANAGER_ROOT + '.parameters_new',
    LIST_VIEW_TABLE_DISPLAY: INTERNSHIPS_MANAGER_ROOT + '.list-view-table-display',
    LIST_VIEW_TABLE_PARAMETERS: INTERNSHIPS_MANAGER_ROOT + '.list-view-table-parameters'
  }),
  INTERNSHIPS_REQUEST: {
    ROOT: INTERNSHIPS_REQUEST_ROOT,
    PARAMETERS: INTERNSHIPS_REQUEST_ROOT + '.parameters'
  },
  GLOBAL_FILTERS: Object.freeze({
    ROOT: GLOBAL_FILTERS_ROOT,
    INTERNSHIP_DATE: GLOBAL_FILTERS_ROOT + '.internship-date',
    INTERNSHIP_SEARCH: GLOBAL_FILTERS_ROOT + '.search',
    INTERNSHIP_FILTERS: GLOBAL_FILTERS_ROOT + '.internship-filters'
  }),
  QUOTAS_TABLE: Object.freeze({
    ROOT: QUOTAS_TABLE_ROOT,
    SELECTED_SCHOOLS: QUOTAS_TABLE_ROOT + '.selected-schools',
    SELECTED_SECTION_TO_YEARS: QUOTAS_TABLE_ROOT + '.selected-section-to-years',
    OVERLAY_SETTINGS: QUOTAS_TABLE_ROOT + '.overlay-settings',
    QUOTAS_MATRIX: QUOTAS_TABLE_ROOT + '.quotas-matrix'
  }),
  PLACES_TABLE: Object.freeze({
    ROOT: PLACES_TABLE_ROOT,
    OVERLAY_SETTINGS: PLACES_TABLE_ROOT + '.overlay-settings',
    QUOTAS_MATRIX: PLACES_TABLE_ROOT + '.quotas-matrix'
  }),
  PLACES_OCCUPANCY_VIEW: Object.freeze({
    ROOT: PLACES_OCCUPANCY_VIEW_ROOT,
    CLIPBOARD: PLACES_OCCUPANCY_VIEW_ROOT + '.clipboard',
    HOSPITAL_DEPARTMENT_VIEW_TOGGLED: PLACES_OCCUPANCY_VIEW_ROOT + '.hospital-department-view-toggled',
    INTERNSHIPS_MATRIX: PLACES_OCCUPANCY_VIEW_ROOT + '.internships-matrix'
  }),
  MISC: Object.freeze({
    ROOT: MISC_ROOT,
    BETA_MODE: MISC_ROOT + '.beta-mode'
  }),
  STUDENTS_VIEW: Object.freeze({
    ROOT: STUDENTS_VIEW_ROOT,
    LIST_PARAMETERS: STUDENTS_VIEW_ROOT + '.list-parameters'
  })
})

export const LOCAL_STORAGE_KEYS_TO_REMOVE_ON_LOGOUT = [
  LOCAL_STORAGE_KEYS.INTERNSHIPS_MANAGER.SCHOOLS,
  LOCAL_STORAGE_KEYS.INTERNSHIPS_MANAGER.INSTITUTIONS,
  LOCAL_STORAGE_KEYS.INTERNSHIPS_MANAGER.SECTIONS,
  LOCAL_STORAGE_KEYS.INTERNSHIPS_MANAGER.OWNERSHIP
]

export default LOCAL_STORAGE_KEYS
